
export default {
  // Navigation
  home: 'Home',
  services: 'Services',
  about: 'About Us',
  gallery: 'Gallery',
  contact: 'Contact',
  admin: 'Admin',
  getQuote: 'Get Free Quote',
  
  // Hero Section
  heroTitle: 'Professional Painting Services in Atlanta',
  heroSubtitle: 'Quality and Experience You Can Trust',
  heroDescription: 'Transform your property with our expert interior and exterior painting services. We proudly use Sherwin Williams premium paints for lasting results.',
  heroInteriorTitle: 'Transform Your Interior Spaces',
  heroInteriorSubtitle: 'Premium Interior Painting Services',
  heroInteriorDescription: 'Create beautiful, lasting impressions with our expert interior painting services using top-quality Sherwin Williams paints.',
  heroCommercialTitle: 'Commercial Painting Excellence',
  heroCommercialSubtitle: 'Professional Commercial Services',
  heroCommercialDescription: 'Enhance your business property with our comprehensive commercial painting and maintenance services.',
  
  // Services
  servicesTitle: 'Our Services',
  servicesSubtitle: 'Complete Painting Solutions for Residential & Commercial Properties',
  interiorPainting: 'Interior Painting',
  exteriorPainting: 'Exterior Painting',
  drywall: 'Drywall & Carpentry',
  pressureWashing: 'Pressure Washing',
  epoxyFloor: 'Epoxy Floor',
  deckStaining: 'Deck Staining',
  
  // About
  aboutTitle: 'About WF & Y Painting LLC',
  aboutDescription: 'With years of experience serving the Atlanta area, we are committed to delivering exceptional painting services with attention to detail and customer satisfaction.',
  
  // Contact
  contactTitle: 'Get Your Free Estimate',
  contactSubtitle: 'Ready to transform your space? Contact us today!',
  phone: 'Phone',
  email: 'Email',
  name: 'Full Name',
  message: 'Project Details',
  submit: 'Send Message',
  
  // Footer
  footerDescription: 'Professional painting services in Atlanta, Georgia. Quality workmanship and customer satisfaction guaranteed.',
  allRightsReserved: 'All rights reserved.',
  
  // Common
  learnMore: 'Learn More',
  viewGallery: 'View Gallery',
  callNow: 'Call Now',
  emailUs: 'Email Us',
  
  // Reviews Section
  reviewsTitle: 'What Our Customers Say',
  reviewsSubtitle: 'Read testimonials from satisfied customers across Atlanta who trust WF & Y Painting for their painting needs',
  reviewsCompleted: 'Projects Completed',
  reviewsRating: 'Average Rating',
  reviewsSatisfaction: 'Customer Satisfaction',
  
  // Individual Reviews
  review1Text: 'WF & Y Painting transformed our living room completely! The attention to detail was incredible and they finished exactly on time. William and his team were professional, clean, and the quality exceeded our expectations.',
  review1Service: 'Interior Painting - Living Room & Kitchen',
  
  review2Text: 'Outstanding exterior painting job on our two-story home. The crew was punctual, respectful, and did excellent prep work. Our house looks brand new and the paint quality is top-notch. Highly recommend!',
  review2Service: 'Exterior Painting - Full House',
  
  review3Text: 'Professional service from start to finish. Maria helped us choose the perfect colors and the painting crew was meticulous. They protected all our furniture and left everything spotless. Amazing work!',
  review3Service: 'Interior Painting - Master Bedroom',
  
  review4Text: 'Best painting company in Atlanta! They painted our office building and the results are fantastic. Great communication, fair pricing, and superior workmanship. We will definitely use them again.',
  review4Service: 'Commercial Painting - Office Building',
  
  review5Text: 'Carlos and the team did an incredible job on our kitchen cabinets and walls. The transformation is stunning! They were clean, efficient, and the quality is exceptional. Worth every penny.',
  review5Service: 'Kitchen Cabinet Painting',
  
  review6Text: 'Excellent drywall repair and painting service. They fixed all the cracks and holes perfectly before painting. You cannot tell there was ever any damage. True professionals who take pride in their work.',
  review6Service: 'Drywall Repair & Interior Painting',
  
  writeReview: 'Write a Review',
};
